import React from 'react';
import { Box, Typography } from '@mui/material';
import MuiPagination from '@mui/material/Pagination';
import { TablePaginationProps } from '@mui/material/TablePagination';
import { gridPageCountSelector, GridPagination, useGridApiContext, useGridSelector } from '@mui/x-data-grid';

const Pagination = ({
  page,
  onPageChange,
  className,
}: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) => {
  const apiRef = useGridApiContext();
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      color="primary"
      shape="rounded"
      size="small"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event as any, newPage - 1);
      }}
    />
  );
};

export const CustomPagination = (props: any) => {
  return <GridPagination ActionsComponent={Pagination} {...props} rowsPerPageOptions={[10, 20]}
    labelDisplayedRows={() => null}/>;
};


export const CustomNoRowsOverlay = () => {
  return (
    <Box
      sx={{
        border: '1px solid #F3F3F3',
        height: '56px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
        borderTop: 'none',
      }}>
      <Typography sx={{
        fontWeight: '300',
        fontStyle: 'italic',
        color: '#080808',
      }}>
        Nothing found
      </Typography>
    </Box>
  );
};
